import StorageService from "./Services/storageService";
import { SearchType } from "./Enums/SearchType";
import { constants } from './constants';
import { FilterType } from './Enums/FilterType';
import { IFilterItem } from './Interfaces/IFilterItem';
import { setElementVisible, setElementDisplay } from './Helpers/htmlHelper';

class SearchMain {

    constructor() {
        const storageService = new StorageService(sessionStorage);
        storageService.clearAll();
        window.GOVUKFrontend.initAll();

        this.registerEvents();
    }

    private registerEvents(): void {
        document.getElementById("searchType")?.addEventListener("change", () => { this.learningTypeChanged()});
        document.getElementById("search")?.addEventListener("click", () => { this.updateFilters() });
    }

    public getSearchType(): string {
        const searchTypeElement = document.getElementById('searchType') as HTMLSelectElement;

        if (searchTypeElement) {
            return searchTypeElement.options[searchTypeElement.selectedIndex].text;
        }
        return '';
    }

    public updateFilters(): void {
        if (this.getSearchType() == SearchType.Qualifications) {
            const storageService = new StorageService(sessionStorage);
            const storageItem = storageService.retrieve('');
            const filterItems: NodeListOf<HTMLInputElement> = document.querySelectorAll("[name='EFAFundingConditions']"); 

            filterItems.forEach(filterItem => {
                if (filterItem.checked) {
                    const filter: IFilterItem = {
                        key: filterItem.value,
                        type: FilterType.EFAFundingConditions,
                        value: <string>filterItem.dataset.description
                    };
                    storageItem.filters.push(filter);
                }
            });

            if (storageItem.filters.length > 0) {
                const hasFilters = document.getElementById('hasClientSideFilters') as HTMLSelectElement;
                hasFilters.value = 'true';
            }

            storageService.store(constants.storageKey, storageItem);
        }
    }

    public learningTypeChanged(): void {
        const fundingConditions = <HTMLDivElement>document.getElementById('EFAFundingConditions');
        const academicYear = <HTMLInputElement>document.getElementById('academicYear');
        const selectedSearchType = this.getSearchType();

        setElementVisible(academicYear, (selectedSearchType === SearchType.Qualifications || selectedSearchType === SearchType.Units));
        setElementDisplay(fundingConditions, selectedSearchType === SearchType.Qualifications)
    }
}

export const searchMain = new SearchMain();